import React from "react";
import { useTranslation } from "react-i18next";
import { ExitButtonView } from "../buttons/ExitButtonView";
import "./modalStyles.css";
export var ExitConfirmModal = function (_a) {
    var onClose = _a.onClose, onExit = _a.onExit;
    var t = useTranslation().t;
    return (React.createElement("div", { className: "large-modal" },
        React.createElement("p", { className: "info-text" }, t("exit.text")),
        React.createElement("div", null,
            React.createElement(ExitButtonView, { onExit: onExit, onClose: onClose }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/views/modals/ExitConfirmModal.tsx
// module id = 105
// module chunks = 1